import { lazy, Suspense, useEffect, useState } from 'react'

const Viewer = lazy(async () => await import('./Viewer'))

/**
 * Website route for the developer-facing preview editor.
 *
 * The normal website bootstrap already owns Redux, translations, MUI, and
 * product metadata. Waiting until after hydration also keeps the WebGL canvas
 * and browser-created default texture out of server-side rendering.
 */
export default function EditorApp() {
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    if(!mounted) return null

    return <Suspense fallback={null}>
        <Viewer />
    </Suspense>
}
